import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import useAuthStore from "store/authStore";

const useCreateMyInstitution = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const { storeUser, storeUserRoles, storeUserPermissions, storeUserObjectPermissions } =
		useAuthStore();
	const history = useHistory();

	const create = async (obj) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(obj);
		const response = await instance.post("/my-institution", body);
		return response;
	};

	return useMutation(create, {
		onSuccess: async ({ data: body }) => {
			const user = body?.data?.user;

			if (user) {
				storeUser(user);
				storeUserRoles(user?.role_name);
				storeUserPermissions(user?.permission_names);
				storeUserObjectPermissions(user?.object_permissions);
			}

			await queryClient.invalidateQueries("profile");
			await queryClient.invalidateQueries("my_institution");
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useCreateMyInstitution;
